"use strict";
var _a;
function svg2html() {
    var elements = document.querySelectorAll("img.svg");
    elements.forEach(function (element) {
        var img = element;
        var imgID = img.getAttribute("id") || "";
        var imgClass = img.getAttribute("class") || "";
        var imgURL = img.getAttribute("src") || "";
        var xhr = new XMLHttpRequest();
        xhr.open("GET", imgURL, true);
        xhr.onreadystatechange = function () {
            var _a;
            if (xhr.readyState === 4 && xhr.status === 200) {
                var data = xhr.response;
                var parser = new DOMParser();
                var svgDoc = parser.parseFromString(data, "image/svg+xml");
                var svg = svgDoc.querySelector("svg");
                if (svg) {
                    if (typeof imgID !== "undefined") {
                        svg.setAttribute("id", imgID);
                    }
                    if (typeof imgClass !== "undefined") {
                        svg.setAttribute("class", imgClass + " replaced-svg");
                    }
                    svg.removeAttribute("xmlns:a");
                    if (img) {
                        (_a = img.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(svg, img);
                    }
                }
            }
        };
        xhr.send();
    });
}
var confettiShown = false;
var ccdConfettiShownDate = localStorage.getItem('ccdConfettiShownDate');
if (ccdConfettiShownDate) {
    var confettiDate = new Date(ccdConfettiShownDate);
    var currentDate = new Date();
    var diffTime = Math.abs(currentDate.getTime() - confettiDate.getTime());
    if (diffTime < 3600000) {
        confettiShown = true;
    }
}
document.addEventListener('DOMContentLoaded', function () {
    svg2html();
}, false);
setupAddToCartListeners();
function setupAddToCartListeners() {
    // Add to cart code for single and grid sections
    var addToCartButtons = document.querySelectorAll('.add-to-cart');
    if (addToCartButtons && addToCartButtons.length) {
        addToCartButtons.forEach(function (addToCartButton) {
            addToCartButton.addEventListener('click', function (e) {
                var _a, _b, _c;
                e.preventDefault();
                (_a = addToCartButton.querySelector('.loading-spinner')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
                (_b = addToCartButton.querySelectorAll('img:not(.loading-spinner):not(.tick)')) === null || _b === void 0 ? void 0 : _b.forEach(function (img) {
                    img.classList.add('d-none');
                });
                (_c = addToCartButton.querySelector('span')) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
                var quantity = 1;
                var productId = parseInt(addToCartButton.getAttribute("data-id") || "0");
                var quantityInput = null;
                // .product-item-add-to-cart is used to indicate it was an add to cart from the product-item component and not a SPP page
                if (!addToCartButton.classList.contains("product-item-add-to-cart")) {
                    if (window.innerWidth < 768) {
                        quantityInput = document.querySelector('.single-product .floated-focus-block .quantity-controller input');
                    }
                    else {
                        quantityInput = document.querySelector('.single-product .focus-block .quantity-controller input');
                    }
                }
                if (quantityInput) {
                    quantity = parseInt(quantityInput.value || "0");
                }
                cart.add_product(productId, quantity, {}, function () {
                    var _a, _b, _c, _d, _e;
                    addToCartButton.classList.add('green-bg');
                    (_a = addToCartButton.querySelector('.loading-spinner')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                    (_b = addToCartButton.querySelector('.tick')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
                    (_c = addToCartButton.querySelectorAll('img:not(.loading-spinner):not(.plus)')) === null || _c === void 0 ? void 0 : _c.forEach(function (img) {
                        img.classList.remove('d-none');
                    });
                    (_d = addToCartButton.querySelector('span')) === null || _d === void 0 ? void 0 : _d.classList.remove('d-none');
                    var span = addToCartButton.querySelector('span');
                    if (span) {
                        span.classList.add('white-text');
                        span.textContent = "Added!";
                    }
                    (_e = document.querySelector('header .cart-counter')) === null || _e === void 0 ? void 0 : _e.classList.add('pulse');
                    setTimeout(function () {
                        var _a;
                        (_a = document.querySelector('header .cart-counter')) === null || _a === void 0 ? void 0 : _a.classList.remove('pulse');
                    }, 500);
                    setTimeout(function () {
                        var _a, _b;
                        addToCartButton.classList.remove('green-bg');
                        (_a = addToCartButton.querySelector('.tick')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                        (_b = addToCartButton.querySelector('.plus')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
                        var span = addToCartButton.querySelector('span');
                        if (span) {
                            span.classList.remove('white-text');
                            span.textContent = "Add to Cart";
                        }
                    }, 2000);
                });
            });
        });
    }
}
var freeShippingUpsells = document.querySelectorAll(".checkout .cart-free-shipping-upsell");
freeShippingUpsells.forEach(function (upsellElement) {
    runFreeShippingUpsell(upsellElement, false);
});
var stickyCartUpsellElement = document.querySelector(".sticky-cart .cart-free-shipping-upsell");
if (stickyCartUpsellElement) {
    runFreeShippingUpsell(stickyCartUpsellElement, true);
}
function runFreeShippingUpsell(upsellElement, isSticky) {
    var _a, _b, _c, _d, _e, _f, _g;
    var cartTotal = parseInt((upsellElement === null || upsellElement === void 0 ? void 0 : upsellElement.getAttribute('data-amount')) || "0");
    if (cartTotal === 0) {
        upsellElement.classList.add("d-none");
    }
    else {
        upsellElement.classList.remove("d-none");
        // First hide or show elements before animating
        if (cartTotal < 70000) {
            (_a = upsellElement.querySelector(".amount-text")) === null || _a === void 0 ? void 0 : _a.classList.remove("d-none");
            (_b = upsellElement.querySelector(".free-delivery")) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
            (_c = upsellElement.querySelector(".free-delivery-success")) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
        }
        else {
            (_d = upsellElement.querySelector(".amount-text")) === null || _d === void 0 ? void 0 : _d.classList.add("d-none");
            (_e = upsellElement.querySelector(".free-delivery")) === null || _e === void 0 ? void 0 : _e.classList.add("d-none");
            (_f = upsellElement.querySelector(".free-delivery-success")) === null || _f === void 0 ? void 0 : _f.classList.remove("d-none");
        }
        var amountToStillSpend = ((70000 - cartTotal) / 100).toFixed(2);
        upsellElement.querySelector(".amount-value").textContent = "R" + amountToStillSpend;
        var percentageComplete = ((cartTotal / 70000) * 100);
        if (percentageComplete > 70 && percentageComplete < 100) {
            percentageComplete = 70;
        }
        if (percentageComplete >= 100) {
            upsellElement.setAttribute('data-got-free-shipping', 'true');
            animateCartToPercentage(upsellElement, 95);
            var currentFreeShippingElementStatus_1 = (upsellElement === null || upsellElement === void 0 ? void 0 : upsellElement.getAttribute('data-got-free-shipping')) || "false";
            setTimeout(function () {
                var _a, _b;
                if (currentFreeShippingElementStatus_1 === "false") {
                    upsellElement.querySelector(".box").style.opacity = "1";
                    upsellElement.querySelector(".progress-bar").style.opacity = "1";
                    upsellElement.querySelector(".progress-bar-bg").style.opacity = "1";
                    (_a = upsellElement.querySelector(".truck")) === null || _a === void 0 ? void 0 : _a.classList.remove("center");
                }
                else {
                    upsellElement.querySelector(".box").style.opacity = "0";
                    upsellElement.querySelector(".progress-bar").style.opacity = "0";
                    upsellElement.querySelector(".progress-bar-bg").style.opacity = "0";
                    (_b = upsellElement.querySelector(".truck")) === null || _b === void 0 ? void 0 : _b.classList.add("center");
                }
            }, 750);
            setTimeout(function () {
                if (currentFreeShippingElementStatus_1 === "false") {
                    upsellElement.querySelector(".free-delivery-success").style.opacity = "0";
                }
                else {
                    upsellElement.querySelector(".free-delivery-success").style.opacity = "1";
                }
            }, 1500);
            setTimeout(function () {
                var _a;
                var targetElement = null;
                if (isSticky && ((_a = document.querySelector('.sticky-cart')) === null || _a === void 0 ? void 0 : _a.classList.contains('open'))) {
                    targetElement = document.querySelector('.sticky-cart .checkout-btn');
                }
                else {
                    targetElement = document.querySelector('.checkout-button.desktop');
                    if (window.innerWidth < 992) {
                        targetElement = document.querySelector('.checkout-button.mobile');
                    }
                }
                if (targetElement && confettiShown === false) {
                    confettiShown = true;
                    localStorage.setItem('ccdConfettiShownDate', new Date().toISOString());
                    var rect = targetElement.getBoundingClientRect();
                    // Get center coordinates of the element
                    var x = (rect.left + rect.width / 2) / window.innerWidth;
                    var y = (rect.top + rect.height / 2) / window.innerHeight;
                    // @ts-ignore
                    confetti({
                        particleCount: 100,
                        spread: 50,
                        origin: {
                            x: x,
                            y: y
                        }
                    });
                }
            }, 1700);
        }
        else {
            upsellElement.setAttribute('data-got-free-shipping', 'false');
            upsellElement.querySelector(".box").style.opacity = "1";
            upsellElement.querySelector(".progress-bar").style.opacity = "1";
            upsellElement.querySelector(".progress-bar-bg").style.opacity = "1";
            (_g = upsellElement.querySelector(".truck")) === null || _g === void 0 ? void 0 : _g.classList.remove("center");
            upsellElement.querySelector(".free-delivery-success").style.opacity = "0";
            animateCartToPercentage(upsellElement, percentageComplete);
        }
    }
}
function animateCartToPercentage(upsellElement, percentageComplete) {
    var percentageCompleteString = percentageComplete.toFixed(0);
    var progressBar = upsellElement.querySelector(".progress-bar");
    var progressIcon = upsellElement.querySelector(".box");
    if (progressBar && progressIcon) {
        progressBar.setAttribute('style', "width: ".concat(percentageCompleteString, "%"));
        var freeDeliveryWidget = upsellElement.querySelector(".free-delivery-widget");
        var elementWidth = (freeDeliveryWidget === null || freeDeliveryWidget === void 0 ? void 0 : freeDeliveryWidget.clientWidth) || 0;
        var widthPercentage = ((elementWidth * (parseInt(percentageCompleteString) / 100)) - 22).toFixed(0);
        progressIcon.setAttribute('style', "left: ".concat(widthPercentage, "px"));
    }
}
var newsletterForms = document.querySelectorAll("form.newsletter-form");
newsletterForms.forEach(function (form) {
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        form.querySelector("button[type='submit']").textContent = "Loading...";
        var formElement = e.target;
        var formData = new FormData(formElement);
        var email = formData.get("email");
        var honeyPot = formData.get("name");
        if (honeyPot) {
            return;
        }
        var newsletterUrl = 'https://ccd-typescript-api-5341184e38bc.herokuapp.com/database/subscribe';
        fetch(newsletterUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email
            })
        }).then(function (response) {
            response.json().then(function (jsonResponse) {
                if (jsonResponse.result === true) {
                    var url = new URL(form.action, window.location.origin);
                    url.searchParams.set('email', email);
                    url.searchParams.set('redirect', 'true');
                    window.location.href = url.toString();
                }
            });
        });
    });
});
// Needed for bfcache
document.addEventListener("DOMContentLoaded", function () {
    cart.update_cart();
});
var subscribePopup = document.querySelector('.subscribe-popup');
var popupBackground = document.querySelector('.popup-background');
var subscribeLocalStorageKey = "subscribe-popup-dismissed";
var showPopup = localStorage.getItem(subscribeLocalStorageKey);
if (!showPopup) {
    var popupShown_1 = false;
    document.addEventListener('scroll', function () {
        if (popupShown_1) {
            return;
        }
        var scrollPosition = window.scrollY || document.documentElement.scrollTop;
        if (scrollPosition > 500 && subscribePopup && popupBackground) {
            popupShown_1 = true;
            localStorage.setItem(subscribeLocalStorageKey, new Date().toISOString());
            subscribePopup.classList.remove("d-none");
            popupBackground.classList.remove("d-none");
            setTimeout(function () {
                var _a;
                (_a = subscribePopup.querySelector(".close")) === null || _a === void 0 ? void 0 : _a.classList.add("rotate");
            }, 500);
        }
    });
    document.querySelectorAll('.subscribe-popup .close, .popup-background').forEach(function (closeButton) {
        closeButton.addEventListener('click', function (e) {
            e.preventDefault();
            if (subscribePopup && popupBackground) {
                subscribePopup.classList.add("d-none");
                popupBackground.classList.add("d-none");
                localStorage.setItem(subscribeLocalStorageKey, new Date().toISOString());
            }
        });
    });
}
var easterEggs = document.querySelectorAll(".easter-egg");
var easterPopup = document.querySelector('.easter-popup');
var easterPopupBackground = document.querySelector('.easter-popup-background');
easterEggs.forEach(function (easterEgg) {
    easterEgg.addEventListener("click", function () {
        var _a;
        var uuid = easterEgg.getAttribute("data-uuid") || "";
        var percentage = easterEgg.getAttribute("data-percentage") || "";
        if (easterEgg.classList.contains("terms-of-service")) {
            uuid = "91c6ebad-b5d1-428f-98b9-aca89fa34dc0";
            percentage = "30";
        }
        easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.classList.remove("d-none");
        easterPopupBackground === null || easterPopupBackground === void 0 ? void 0 : easterPopupBackground.classList.remove("d-none");
        easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.setAttribute("data-uuid", uuid);
        var copy = getPercentageCopy(percentage);
        console.log({
            easterEgg: easterEgg,
            copy: copy,
            uuid: uuid
        });
        if (copy) {
            (_a = easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.querySelector(".image-wrapper img")) === null || _a === void 0 ? void 0 : _a.setAttribute("src", copy.img);
            var titleElement = easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.querySelector(".content-wrapper .title");
            if (titleElement) {
                titleElement.textContent = copy.title;
            }
            var descriptionElement = easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.querySelector(".content-wrapper .description");
            if (descriptionElement) {
                descriptionElement.innerHTML = copy.description;
            }
        }
    });
});
function getPercentageCopy(percentage) {
    switch (percentage) {
        case "5":
            return {
                img: "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/5_f87de363-7779-445d-a7ce-d774ea220e11.jpg?v=1774272256",
                title: "Well Spotted!",
                description: "Yay! You found a <b>Teal Egg</b> and won a <b>5% discount</b>. Enter your email below to receive your unique code."
            };
        case "10":
            return {
                img: "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/10_d5e15c67-f8fa-4c27-87d4-a5dd0c695fc1.png?v=1775042307",
                title: "Fast Fingers!",
                description: "Enter your email below to find out if you are a winner."
            };
        case "15":
            return {
                img: "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/15.jpg?v=1774272583",
                title: "Incredible Find!",
                description: "You’ve tracked down a <b>Silver Egg</b> and won a <b>15% discount</b>. Enter your email below to receive your unique code."
            };
        case "30":
            return {
                img: "https://cdn.shopify.com/s/files/1/0505/3071/3798/files/30_354a2633-23a8-4315-9258-6b7224ac1ed3.png?v=1775042307",
                title: "YOU’VE DONE IT!",
                // description: "The <b>Golden Egg</b> is yours, along with a massive <b>30% discount</b>. Enter your email below to receive your one-of-a-kind code."
                description: "Enter your email below to find out if you are a winner."
            };
        default:
            break;
    }
}
document.querySelectorAll('.easter-popup .close, .easter-popup-background').forEach(function (closeButton) {
    closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (easterPopup && easterPopupBackground) {
            easterPopup.classList.add("d-none");
            easterPopupBackground.classList.add("d-none");
        }
    });
});
(_a = document.querySelector(".easter-popup form button")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function (e) {
    var _a, _b, _c, _d, _e;
    e.preventDefault();
    var form = document.querySelector(".easter-popup form");
    var formData = new FormData(form);
    var email = formData.get("email");
    var honeyPot = formData.get("name");
    if (honeyPot) {
        return;
    }
    // const easterUrl: string = "https://untenaciously-superindependent-lilia.ngrok-free.dev/easter/redeem";
    var easterUrl = "https://ccd-typescript-api-5341184e38bc.herokuapp.com/easter/redeem";
    var uuid = (easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.getAttribute("data-uuid")) || "";
    (_a = document.querySelector(".easter-popup form")) === null || _a === void 0 ? void 0 : _a.classList.remove("d-flex");
    (_b = document.querySelector(".easter-popup form")) === null || _b === void 0 ? void 0 : _b.classList.add("d-none");
    (_c = document.querySelector(".easter-popup .title")) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
    (_d = document.querySelector(".easter-popup .description")) === null || _d === void 0 ? void 0 : _d.classList.add("d-none");
    (_e = document.querySelector(".easter-popup .easter-loading")) === null || _e === void 0 ? void 0 : _e.classList.remove("d-none");
    fetch(easterUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-api-key": "Uw3TnJjUgY48yG!e2pAzGis2Gg",
            "x-code": uuid
        },
        body: JSON.stringify({
            email: email
        })
    }).then(function (response) {
        response.json().then(function (jsonResponse) {
            var _a, _b, _c;
            console.log({
                status: response.status,
                jsonResponse: jsonResponse
            });
            var resultCopy = getResultCopy(jsonResponse.result);
            (_a = document.querySelector(".easter-popup .easter-loading")) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
            (_b = document.querySelector(".easter-popup .title")) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
            (_c = document.querySelector(".easter-popup .description")) === null || _c === void 0 ? void 0 : _c.classList.remove("d-none");
            var titleElement = easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.querySelector(".content-wrapper .title");
            if (titleElement) {
                titleElement.textContent = resultCopy.title;
            }
            var descriptionElement = easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.querySelector(".content-wrapper .description");
            if (descriptionElement) {
                descriptionElement.innerHTML = resultCopy.description;
            }
        });
    }).catch(function (error) {
        var _a, _b, _c;
        console.error("Error redeeming easter egg:", error);
        (_a = document.querySelector(".easter-popup .easter-loading")) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
        (_b = document.querySelector(".easter-popup .title")) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
        (_c = document.querySelector(".easter-popup .description")) === null || _c === void 0 ? void 0 : _c.classList.remove("d-none");
        var resultCopy = getResultCopy("ERROR");
        var titleElement = easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.querySelector(".content-wrapper .title");
        if (titleElement) {
            titleElement.textContent = resultCopy.title;
        }
        var descriptionElement = easterPopup === null || easterPopup === void 0 ? void 0 : easterPopup.querySelector(".content-wrapper .description");
        if (descriptionElement) {
            descriptionElement.innerHTML = resultCopy.description;
        }
    });
});
function getResultCopy(result) {
    switch (result) {
        case "SUCCESS":
            return {
                title: "It’s on its way!",
                description: "Check your inbox! Your unique discount code is on its way to you. Use the unique discount code at checkout to claim your savings."
            };
        case "NO_REDEMPTIONS_LEFT":
            return {
                title: "The Hunt is Over!",
                description: "This specific egg has already been found by another lucky hunter. But dont turn back now, you can still find the 5%, 10% and 15% OFF eggs hidden across the website, keep searching!"
            };
        case "ALREADY_REDEEMED":
            return {
                title: "You’ve already bagged this one!",
                description: "This specific discount is already in your pocket (check your inbox) Don’t worry, there are still other colours hidden out there. Keep searching!"
            };
        case "ERROR":
        default:
            return {
                title: "An error occurred!",
                description: "An error occurred while redeeming the easter egg. Please try again later."
            };
    }
}
